export var RequestStatus = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus[RequestStatus["Processing"] = 0] = "Processing";
    RequestStatus[RequestStatus["Success"] = 1] = "Success";
    RequestStatus[RequestStatus["Failure"] = 2] = "Failure";
    return RequestStatus;
}({});

//# sourceMappingURL=types.js.map